export const DELIVERY_METHODS = ['live-api', 'manual', 'export']
export const DELIVERY_SOURCES = [
  'live-api',
  'manual',
  'export',
  'legacy-migration',
  'snapshot-import',
  'unknown',
]

const CONFIGURATION_REASON_CODES = new Set([
  'CONFIGURATION_REQUIRED',
  'INTEGRATION_STATE_UNKNOWN',
  'LIVE_POSTING_DISABLED',
  'PLANNING_ONLY_QUEUE',
])

function cleanString(value) {
  return typeof value === 'string' ? value.trim() : ''
}

function includesAny(value, tokens) {
  return tokens.some((token) => value.includes(token))
}

function buildFailureText(latestAttempt) {
  return `${cleanString(latestAttempt?.errorCode)} ${cleanString(
    latestAttempt?.errorMessage
  )}`.toUpperCase()
}

export function normalizeDeliveryMethod(value, fallback = 'manual') {
  const cleaned = cleanString(value)
  if (DELIVERY_METHODS.includes(cleaned)) return cleaned
  return DELIVERY_METHODS.includes(fallback) ? fallback : 'manual'
}

export function normalizeDeliverySource(value, method = 'manual') {
  const cleaned = cleanString(value)
  if (DELIVERY_SOURCES.includes(cleaned)) return cleaned
  const normalizedMethod = normalizeDeliveryMethod(method)
  if (normalizedMethod === 'live-api') return 'live-api'
  if (normalizedMethod === 'export') return 'export'
  return 'manual'
}

export function classifyPublishFailure({
  latestAttempt = null,
  publishReadiness = null,
  lengthMetrics = null,
} = {}) {
  const failureText = buildFailureText(latestAttempt)
  const code = cleanString(latestAttempt?.errorCode).toUpperCase()
  const readinessCode = cleanString(publishReadiness?.reasonCode)

  if (lengthMetrics?.isValid === false) {
    return {
      recoveryState: 'content-blocked',
      failureClass: 'content-blocked',
    }
  }

  if (CONFIGURATION_REASON_CODES.has(readinessCode)) {
    return {
      recoveryState: 'needs-configuration',
      failureClass: 'needs-configuration',
    }
  }

  if (
    includesAny(failureText, [
      'CREDENTIAL',
      'TOKEN',
      'AUTHENTICATION',
      'AUTHORIZATION',
      'UNAUTHORIZED',
      'FORBIDDEN',
    ])
  ) {
    return {
      recoveryState: 'retry-ready',
      failureClass: 'credential',
    }
  }

  if (
    includesAny(failureText, ['CONTENT', 'LENGTH', 'TOO_LONG', 'INVALID_TEXT'])
  ) {
    return {
      recoveryState: 'content-blocked',
      failureClass: 'content-blocked',
    }
  }

  if (latestAttempt?.outcome === 'failure') {
    return {
      recoveryState: 'retry-ready',
      failureClass: code ? 'provider' : 'unknown',
    }
  }

  return {
    recoveryState: publishReadiness?.disabled
      ? 'needs-configuration'
      : 'unknown',
    failureClass: 'unknown',
  }
}

export default {
  DELIVERY_METHODS,
  DELIVERY_SOURCES,
  normalizeDeliveryMethod,
  normalizeDeliverySource,
  classifyPublishFailure,
}
